import { ADMIN_ROUTE_PREFIX, AGENT_ROUTE_PREFIX } from '@/constants/security';
import type { MyAccessContext } from '@/types/profiles';

const PRIVATE_ROUTE_PREFIXES = [
  ADMIN_ROUTE_PREFIX,
  AGENT_ROUTE_PREFIX,
  '/propietario/dashboard',
  '/inquilino/dashboard',
  '/proveedor/dashboard',
] as const;

function normalizeLocalPath(path: string | null | undefined): string | null {
  if (!path) return null;

  const normalized = path.trim();
  if (!normalized.startsWith('/')) return null;

  return normalized;
}

export function isSensitivePrivateRoute(path: string | null | undefined): boolean {
  const normalized = normalizeLocalPath(path);
  if (!normalized) return false;

  return PRIVATE_ROUTE_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`));
}

interface ResolveCanonicalPostAuthDestinationOptions {
  accessContext: MyAccessContext | null;
  requestedPath?: string | null;
  fallbackPath?: string;
}

export function resolveCanonicalPostAuthDestination({
  accessContext,
  requestedPath,
  fallbackPath = '/',
}: ResolveCanonicalPostAuthDestinationOptions): string {
  const normalizedRequestedPath = normalizeLocalPath(requestedPath);

  if (normalizedRequestedPath && !isSensitivePrivateRoute(normalizedRequestedPath)) {
    return normalizedRequestedPath;
  }

  if (accessContext?.dashboardPath) {
    return accessContext.dashboardPath;
  }

  return fallbackPath;
}